import { render, staticRenderFns } from "./ScrollPane.vue?vue&type=template&id=1f917c86&scoped=true&"
import script from "./ScrollPane.vue?vue&type=script&lang=js&"
export * from "./ScrollPane.vue?vue&type=script&lang=js&"
import style0 from "./ScrollPane.vue?vue&type=style&index=0&id=1f917c86&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f917c86",
  null
  
)

export default component.exports